import React, { useEffect } from 'react';
import Hls from '/scripts/hls-js-1.3.4/hls.min.js'

export const HLSJS = (props) => {

  useEffect(() => {
    if (Hls.isSupported()) {
      var video = document.getElementById('video');
      var hls = new Hls({
        xhrSetup: xhr => {
          xhr.setRequestHeader('Authorization', 'Bearer ' + props.token);
        }
      });
      hls.on(Hls.Events.MEDIA_ATTACHED, function () {
        console.log('video and hls.js are now bound together !');
      });
      hls.on(Hls.Events.MANIFEST_PARSED, function (event, data) {
        console.log(
          'manifest loaded, found ' + data.levels.length + ' quality level'
        );
      });
      console.log("Loading source: " + props.options.source);
      hls.loadSource(props.options.source);
      // bind them together
      hls.attachMedia(video);
    }
  }, []);


  return (
    <div data-hls-player>
      <video id="video" className="live-player"  controls></video>
    </div>
  );
}

export default HLSJS;